import CacheHealth from './interfaces/CacheHealth';
import CacheInstallationState from './interfaces/CacheInstallationState';
import ClientAction from './interfaces/ClientAction';
import ClientMessage from './interfaces/ClientMessage';
import ServiceWorkerMessage from './interfaces/ServiceWorkerMessage';
import ServiceWorkerMessageType from './interfaces/ServiceWorkerMessageType';
import cacheProgressEventDispatcher from './cacheProgressEventDispatcher';
import serviceWorkerErrorEvent from './serviceWorkerErrorEvent';
import { getConsecutiveErrorCount } from './consecutiveErrorCount';
import { isFeatureEnabled } from 'owa-feature-flags';

const MAX_CONSECUTIVE_ERROR: number = 15;

let state: CacheInstallationState = null;
let windowObj: Window = null;

export function resetGlobals(): void {
    state = null;
    windowObj = null;
}

export function tryInitializeServiceWorkerCacheInstaller(
    installationState: CacheInstallationState,
    windowObject: Window
): void {
    if (state == null) {
        state = installationState;
        state.serviceWorkerContainer.onmessage = serviceWorkerMessageEvent;
        if (getConsecutiveErrorCount(window, state) > MAX_CONSECUTIVE_ERROR) {
            state.cacheHealth = CacheHealth.TooManyInstallError;
        }
    }

    windowObj = windowObject;
}

export function installServiceWorkerCache(): void {
    let manifestUrl: string = `${
        state.serviceWorkerPath != null
            ? `${state.serviceWorkerPath}/${state.appName}cache.manifest`
            : `/${state.appName}cache.manifest`
    }?manifestVersion=2`;
    let action: ClientAction = ClientAction.Install;

    // If cache health is not normal then first uninstall it
    if (state.cacheHealth > CacheHealth.Normal) {
        action = ClientAction.UnInstall;
    }

    let clientMessage: ClientMessage = {
        source: state.appName,
        action: action,
        bootResourcesOnly: true,
        language: state.userLanguage,
        darkMode: state.darkMode !== undefined ? state.darkMode : false,
        manifestUrl: manifestUrl,
        proxyFetchAlways: isFeatureEnabled('fwk-sw-proxyFetchAlways'),
    };
    state.serviceWorkerRegistration.active.postMessage(clientMessage);
}

export function serviceWorkerMessageEvent(messageEvent: MessageEvent): void {
    if (messageEvent.data != null) {
        let message: ServiceWorkerMessage = messageEvent.data;
        if (message.messageType == ServiceWorkerMessageType.CacheProgress) {
            cacheProgressEventDispatcher(windowObj, state, message);
        } else if (message.messageType == ServiceWorkerMessageType.Error) {
            serviceWorkerErrorEvent(message);
        }
    }
}
